const set = require('regenerate')(0x302, 0x304, 0x323, 0x2D7F);
set.addRange(0x306, 0x309).addRange(0x2D30, 0x2D67).addRange(0x2D6F, 0x2D70);
exports.characters = set;
